import { connect } from "react-redux";
import { getSession } from "../../selectors";
import React from "react";
import { Redirect } from "react-router-dom";

export default function(Component, url) {
  var klass = function(props) {
    var { session } = props;
    if (session.get("user_id") !== undefined) {
      return <Redirect to={url} />;
    }
    return <Component {...props} />;
  };
  return connect(select)(klass);
}

function select(state) {
  return {
    session: getSession(state)
  };
}
